import React, { useRef } from 'react';
import { useDrop, DndProvider, useDrag } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ElementTemplate } from '../TemplateComponent';

function GrandTotalSection({ element, fromForm, index, dropLocation }) {
  const { t } = useTranslation('common');

  function GTData() {
    const GTRef = useRef(null);
    const [{ item, handlerId, isOver }, drop] = useDrop({
      accept: 'container',
      drop: () => {
        dropLocation(index, item);
      },
      collect: (monitor) => ({
        item: monitor.getItem(),
        handlerId: monitor.getHandlerId(),
        isOver: monitor.isOver(),
      }),
    });
    const [{ itemDragging }] = useDrag({
      type: 'container',
      collect: (monitor) => ({
        itemDragging: monitor.getItem(),
      }),
    });
    drop(GTRef);
    return (
      <div ref={GTRef} data-handler-id={handlerId} key={`${element?.key}_${index}`}>
        {' '}
        {isOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.GRAND_TOTAL_SECTION.DROP_SECTION_HERE')}</div>}
        <Card className="listing-card">
          <Card.Header className="px-2 py-2 bgcolor-dark">
            <strong>{element?.label}</strong>
          </Card.Header>
          {itemDragging?.type !== 'container' && (
            <Card.Body className="py-4">
              {element?.columns?.map((colElement, i) => {
                return (
                  <Row key={i} className="span_font_size">
                    {colElement?.map((colEle, index) => {
                      return (
                        colEle.label !== t('PO_TEMPLATES.PO_DETAILS.GRAND_TOTAL_SECTION.GRAND_TOTAL_BEFOR_PRICE') && (
                          <Col lg={6} key={index}>
                            <div className="d-flex py-1">
                              <ElementTemplate
                                keys={colEle?.key}
                                name={colEle?.label}
                                placeHolder={colEle?.placeholder}
                                label={colEle?.label}
                                disable
                                requiredField={colEle?.required}
                                onlyRead
                              />
                            </div>
                          </Col>
                        )
                      );
                    })}
                  </Row>
                );
              })}
            </Card.Body>
          )}
        </Card>
      </div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      {fromForm ? (
        <GTData />
      ) : (
        <Card className="listing-card">
          <Card.Header className="px-2 py-2 bgcolor-dark">
            <strong>{element?.label}</strong>
          </Card.Header>
          <Card.Body className="py-4">
            {element?.columns?.map((colElement, i) => {
              return (
                <Row key={i} className="span_font_size">
                  {colElement?.map((colEle, colIndex) => {
                    return (
                      colEle.label !== t('PO_TEMPLATES.PO_DETAILS.GRAND_TOTAL_SECTION.GRAND_TOTAL_BEFOR_PRICE') && (
                        <Col lg={6} key={colEle?.key || colIndex}>
                          <div className="d-flex py-1">
                            <ElementTemplate
                              keys={colEle?.key}
                              name={colEle?.label}
                              placeHolder={colEle?.placeholder}
                              label={colEle?.label}
                              disable
                              requiredField={colEle?.required}
                              onlyRead
                            />
                          </div>
                        </Col>
                      )
                    );
                  })}
                </Row>
              );
            })}
          </Card.Body>
        </Card>
      )}
    </DndProvider>
  );
}

export default GrandTotalSection;
